import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {Grid, Card,TextField, Avatar} from '@material-ui/core';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import HelperFormatData from "../../HelperFormatData";
const darkmode = 'background: rgb(0,24,52);\n' +
    'background: linear-gradient(152deg, rgba(0,24,52,1) 0%, rgba(0,24,52,1) 35%, rgba(4,55,113,1) 92%, rgba(7,90,185,1) 98%);'

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        padding: theme.spacing(2),
        color: '#ffffff',
    },
    card: {
        height: '100%',
        backgroundColor: darkmode,

    },
    infocardContent: {
        textAlign: 'left',
    },
    cardContent: {
        textAlign: 'center',
        color: '#ffffff',
    },
    profile:{
        color: '#ffffff',
    },
    avatar: {
        width: '100px',
        height: '100px',
        borderRadius: '50%',
        margin: 'auto',
        marginBottom: theme.spacing(1),
    },
    input: {
        marginBottom: theme.spacing(2),
    },
    badgeActive: {
        backgroundColor: '#00ff00',
        color: '#ffffff',
    },
    badgeInactive: {
        backgroundColor: '#ff0000',
        color: '#ffffff',
    },
}));

const Perfil = (user) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <Card className={classes.card}>
                        <CardContent className={classes.cardContent}>
                            <Typography variant="h5" component="h2" className={classes.profile}>
                                <div className={classes.infocardContent}>
                                  <h2>  {user.user.name}</h2>

                                    <div>
                                      <ul>
                                          <li>
                                              e-mail:   {user.user.email}
                                          </li>
                                          <li>
                                              data de nascimento: {HelperFormatData(user.user.data_nascimento)}
                                          </li>
                                          <li>
                                              Unidade alocado:
                                          </li>
                                          <li>
                                              Cargo :
                                          </li>
                                      </ul>
                                    </div>
                                </div>
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </div>
    );
};

export default Perfil;